// extracted by mini-css-extract-plugin
module.exports = {"shape":"RoundedButton_shape__3iMng","label":"RoundedButton_label__3a2IO","disabled":"RoundedButton_disabled__2E-TE"};